import { useTranslation } from 'react-i18next';
import { Autocomplete } from '@avangard/ui/core';

import { usePageFilters, PageFiltersToolbar } from '@modules/shared/organisms';
import { useCourses } from '@modules/courses/hooks';

import type { LapsTableFilters } from '@modules/lap/hooks';
import type { CourseEntity } from '@modules/courses/entities';

const ToolbarFilters = () => {
    const { t } = useTranslation(['common']);

    const {
        filters,
        handleChangeAutocomplete,

        getOptionValue,
        getOptionLabel,
    } = usePageFilters<LapsTableFilters>();

    const { courses, loading: coursesLoading } = useCourses();

    return (
        <PageFiltersToolbar hideDrawerFilterButton>
            <Autocomplete<CourseEntity | null, false, false, false>
                fullWidth
                id='courseId'
                placeholder={t('common:forms.placeholder.choose_course') ?? ''}
                options={courses}
                value={getOptionValue(courses, filters.courseId)}
                disabled={coursesLoading}
                getOptionLabel={getOptionLabel('name')}
                onChange={handleChangeAutocomplete()}
            />
        </PageFiltersToolbar>
    );
};

export { ToolbarFilters };
